import { FC, ReactNode, useState } from "react";
import { StayDataType } from "data/types";
import HeaderFilter from "./HeaderFilter";
import { useNavigate } from "react-router-dom";
import { useData } from "data/data-provider";
import { CarListingModal } from "models/vehicleModal";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import FleetCard from "designs/DesignB/components/FleetCard/FleetCard";

// OTHER DEMO WILL PASS PROPS
const DEMO_DATA: StayDataType[] = [];

//
export interface SectionGridFeaturePlacesProps {
  stayListings?: StayDataType[];
  gridClass?: string;
  heading?: ReactNode;
  subHeading?: ReactNode;
  headingIsCenter?: boolean;
  tabs?: string[];
}

const SectionGridFeaturePlaces: FC<SectionGridFeaturePlacesProps> = ({
  stayListings = DEMO_DATA,
  gridClass = "",
  heading = "Popular Cars",
  subHeading = "Popular places to stay that Chisfis recommends for you",
  headingIsCenter,
  tabs = ["New York", "Tokyo", "Paris", "London"],
}) => {
  const { ourVehicles, ourVehiclesLoading, setSelectedCar } = useData();
  const [visibleCarsCount, setVisibleCarsCount] = useState<number>(8); // Track how many cars are visible
  const [expanded, setExpanded] = useState<boolean>(false); // Track if all cars are visible
  const navigate = useNavigate();

  const renderCard = (car: CarListingModal) => (
    <FleetCard
      key={car.id}
      data={car}
      simpleImg={true}
      onClick={() => {
        navigate("/car-listing-detail?selectedCarId=" + car.id);
        setSelectedCar(car);
      }}
    />
  );

  // Determine how many cars to show based on visibleCarsCount
  const carsToDisplay = ourVehicles?.slice(0, visibleCarsCount);

  const handleShowMore = () => {
    // Increment the visible cars count by 8 each time
    setVisibleCarsCount((prevCount) => prevCount + 8);
    if (ourVehicles && visibleCarsCount + 8 >= ourVehicles.length) {
      setExpanded(true); // Set expanded to true if all cars are visible
    }
  };

  const handleShowLess = () => {
    // Collapse back to the first 8 cars
    setVisibleCarsCount(8);
    setExpanded(false); // Collapse the list
  };

  return (
    <div className="nc-SectionGridFeaturePlaces relative">
      <HeaderFilter
        tabActive={"New York"}
        subHeading={subHeading}
        tabs={tabs}
        heading={heading}
        count={!ourVehiclesLoading && ourVehicles ? ourVehicles.length : undefined}
        onClickTab={() => {}}
      />
      <div
        className={`grid gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 ${gridClass}`}
      >
        {ourVehiclesLoading ? (
          <div className="flex justify-center items-center col-span-full">
            <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full border-t-transparent border-gray-300"></div>
          </div>
        ) : (
          carsToDisplay?.map((car) => renderCard(car))
        )}
      </div>
      {/* Show "Show me more" button if not all cars are shown */}
      {!expanded && ourVehicles?.length > visibleCarsCount && (
        <div className="flex mt-16 justify-center items-center">
          <ButtonPrimary className="rounded-lg text-text-color" onClick={handleShowMore}>
            Load More
          </ButtonPrimary>
        </div>
      )}

      {/* Show "Show less" button if the list is expanded */}
      {expanded && (
        <div className="flex mt-16 justify-center items-center">
          <ButtonPrimary className="rounded-lg text-text-color" onClick={handleShowLess}>
            Load Less
          </ButtonPrimary>
        </div>
      )}
    </div>
  );
};

export default SectionGridFeaturePlaces;
